import { createComponent } from '@mtfe/sweet';
import { dom, common, eventBus } from '@mtfe/sweet-utils';
import PoiListComp from '../common/PoiListComp/script';
import componentUtils from '../utils/index';

import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const { getOnClickEventName } = componentUtils;

const SEARCH_RESULT_ID = createUniqueId();

// 参数缓存
let propsCache = {};

const SearchResultReady = (listInfo) => {
    eventBus.$onceOn('SearchResultReady', () => {
        if (listInfo) {
            eventBus.$emit(getOnClickEventName(listInfo.recallBizId));
        }
    });
};

/**
 * 搜索结果页面
 * @param {Object} props
 * @returns
 */
const SearchResult = async (props = {}) => {
    propsCache = { ...propsCache, ...props };
    const { renderPoiFunc, http, scrollLoading, listInfoResult, listInfoRecommend, fetchDataList } =
        propsCache;

    try {
        const searchResArray = await fetchDataList({ listInfo: listInfoResult });
        const searchFailed = searchResArray.length === 0;
        const listInfo = searchFailed ? listInfoRecommend : listInfoResult;
        if (!searchFailed) {
            listInfo.poiList.push(...searchResArray);
        }
        // 数据
        const data = {
            SEARCH_RESULT_ID,
            searchFailed,
            poiList: listInfo
                ? PoiListComp({
                      listInfo,
                      scrollLoading,
                      http,
                      renderPoiFunc,
                      fetchDataList,
                  })
                : '',
        };

        const events = {};
        SearchResultReady(listInfo);
        return createComponent(tpl, { data, style }, events);
    } catch (error) {
        console.error('SearchResult error', error);
    }
};

const renderSearchResult = async (props = {}) => {
    propsCache = { ...propsCache, ...props };
    const component = await SearchResult(propsCache);
    dom.$id(SEARCH_RESULT_ID).outerHTML = component;
};
SearchResult.render = renderSearchResult;

export default SearchResult;
